import { useEffect } from 'react';

// JOBE-0193: SPA route changes never updated document.title — every
// route inherited the static title set by index.html. This hook lets
// each top-level page set a tab title; on unmount the previous title
// is restored so a back navigation doesn't leak the current page's
// label.
//
// Usage: `useDocumentTitle('Projects')` → tab reads `Projects — Jobe`.
// Passing `null`/`undefined` falls back to a bare `Jobe`, useful while
// detail pages are still resolving their entity name.

const SUFFIX = ' — Jobe';

export function useDocumentTitle(title) {
  useEffect(() => {
    const prev = document.title;
    document.title = title ? `${title}${SUFFIX}` : 'Jobe';
    return () => { document.title = prev; };
  }, [title]);
}
